// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const misdreavus: PokeData = {
  "id": 200,
  "name": "misdreavus",
  "height": 7,
  "weight": 10,
  "base_experience": 87,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "growl",
    "psybeam",
    "confusion",
    "hypnosis",
    "confuse-ray",
    "psywave",
    "spite",
    "perish-song",
    "mean-look",
    "pain-split",
    "shadow-ball",
    "grudge",
    "astonish",
    "extrasensory",
    "payback",
    "power-gem",
    "shadow-sneak",
    "hex"
  ],
  "moves": [
    "growl",
    "confuse-ray",
    "psywave",
    "shadow-ball",
    "shadow-sneak",
    "spectral-snatch",
    "night-shade",
    "poltergeist",
    "shadow-dagger",
    "lick",
    "spectral-chain",
    "soul-sacrifice",
    "shadow-claws"
  ],
  "evolution_chain": {
    "id": 98,
    "item": null,
    "species": [
      {
        "name": "misdreavus",
        "order": 229,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mismagius",
        "order": 230,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 200,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dusk-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 66.25,
    "speed": 85,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
